import Vue from 'vue';
import VueRouter from 'vue-router';
import $ from 'jquery';
import store from './store/main';

Vue.config.delimiters = ['[[', ']]'];
Vue.use(VueRouter);

// generic global components
import PreLoader from './components/pre-loader/main';
import AudioPlayer from './components/audio-player/main';

// route specific components
import Heroes from './components/heroes/main';
import OkMap from './components/map/main';
import Videos from './components/videos/main';
import About from './components/about/main';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Heroes
  },
  {
    path: '/map',
    name: 'map',
    component: OkMap
  },
  {
    path: '/map/:modal',
    name: 'mapModal',
    component: OkMap
  },
  {
    path: '/videos/:id/:time',
    name: 'videos',
    component: Videos
  },
  {
    path: '/videos/:id',
    name: 'videos',
    component: Videos
  },
  {
    path: '/about',
    name: 'about',
    component: About
  }
];

const router = new VueRouter({routes});

router.beforeEach(function(to, from, next) {
  store.dispatch('routeChange', from);
  next();
});

new Vue({
  el: '#okapp',
  store,
  router,
  mounted () {
    let $vm = this;
    let $body = $('body');
    this.$store.dispatch('getContent');
    if(this.$route.name !== 'home') {
      this.$store.dispatch('preloaded');
      this.$store.dispatch('logoAnimated');
      this.$store.dispatch('showNav');
    }

    // hacky way to test for touch devices
    let mouseOverCheck = (e) => {
      if(e.type === 'mouseover') {
        $vm.$store.dispatch('notTouchDevice');
      } else if (e.type === 'touchstart') {
        // do nothing, we have a touch device
      }
      $body.off('mouseover touchstart', mouseOverCheck);
    };
    $body.on('mouseover touchstart', mouseOverCheck);
  },
  components: {PreLoader, AudioPlayer},
  computed: {
    ui () {
      return this.$store.state.ui;
    },
    page () {
      return this.$route.name + '-page';
    }
  }

});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/main.js